import React, { useMemo } from "react";
import Chart from "react-apexcharts";
import { THEME_COLORS } from "../../../../../color";

const Piechart = ({
  width = 420, // Consistent with DonutChart
  height = 420, // Consistent with DonutChart
  colors = [THEME_COLORS.green, THEME_COLORS.yellow, THEME_COLORS.darkblue],

  data = [],
  options = {},
  icon = null,
  title = "",
}) => {
  const labels = useMemo(() => {
    return data.map((item) => item.name);
  }, [data]);

  const values = useMemo(() => {
    return data.map((item) => item.value);
  }, [data]);

  const totalSum = useMemo(() => {
    return values.reduce((a, b) => a + (b || 0), 0);
  }, [values]);

  const isZero = totalSum === 0;

  const chartSeries = useMemo(() => {
    return isZero ? values.map(() => 1) : values;
  }, [isZero, values]);

  const fOptions = {
    chart: {
      type: "pie",
      width: width,
      height: height,
    },
    labels,
    colors: colors,
    dataLabels: {
      enabled: isZero ? false : true,
      textAnchor: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: "14px",
        fontWeight: 800,
        colors: ["#fff"],
      },
      dropShadow: {
        enabled: false,
      },
    },
    legend: {
      show: true,
      position: "right",
      width: 130,
      offsetY: 0,
      fontSize: "12px",
      fontWeight: 700,
      itemMargin: {
        horizontal: 10,
        vertical: 8,
      },
      markers: {
        size: 12,
        shape: "square",
        strokeWidth: 1,
        fillColors: undefined,
        customHTML: undefined,
        onClick: undefined,
        offsetX: 1,
        offsetY: 0,
      },
    },
    plotOptions: {
      pie: {
        startAngle: 0,
        endAngle: 360,
        expandOnClick: true,
        offsetX: 0,
        offsetY: 0,
        customScale: 1,
        dataLabels: {
          offset: -70,
          minAngleToShowLabel: -4,
        },
      },
    },
    responsive: [
      {
        breakpoint: 1024,
        options: {
          chart: { width: 350, height: 350 },
          legend: {
            position: "bottom",
            offsetY: 10,
          },
          dataLabels: {
            style: {
              fontSize: "14px",
            },
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: { width: 280, height: 280 },
          legend: {
            position: "bottom",
            offsetY: 5,
            fontSize: "10px",
          },
          dataLabels: {
            style: {
              fontSize: "12px",
            },
          },
        },
      },
    ],
    tooltip: {
      y: {
        formatter: (val) => (isZero ? "0" : val),
      },
    },
    states: {
      hover: { filter: { type: "none" } },
      active: { filter: { type: "none" } },
    },
    ...options,
  };

  return (
    <div className="w-full">
      <div className="flex gap-x-4 items-center mb-2">
        <div className=" p-1 ">{icon}</div>
        <h2
          className="text-[1.15rem] font-semibold leading-6"
          style={{ color: THEME_COLORS.green }}
        >
          {title}
        </h2>
      </div>
      <div className="flex justify-center items-center">
        <Chart
          type="pie"
          series={chartSeries}
          width={width}
          height={height}
          options={fOptions}
        />
      </div>
    </div>
  );
};

export default Piechart;
